
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/licensing",
      function () {
        return require("private-next-pages/licensing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/licensing"])
      });
    }
  